import { RootState } from 'store';

export const getABTestExperiment = (state: RootState) => state?.abTestExperiment;
